import React, { useState, useEffect } from "react";
import Widgets from "../../widgets";
import { useTranslation } from "react-i18next";
import Icons from "../../Assets/Icons";
import { format } from "date-fns";
import DatePicker from "react-multi-date-picker";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getEditRequest, updateEditRequest } from "../../modules/patientProfile/patientProfileThunk";
import ToastPopup from "../../widgets/Toast/toastPopup";

const EditPersonalInfo = ({ userId, setSelectedView, setPage, editProfileData, setStatus }) => {
  const { status: status } = useSelector((state) => state.status);
  const { updateEditRequestData, updateEditRequestError } = useSelector((state) => state.patientProfile);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [user, setUser] = useState(null);
  const [rawDate, setRawDate] = useState({});
  const [isDisabled, setIsDisabled] = useState(true);
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
  });
  const navigate = useNavigate();
const getFormattedDate = (date) => {
  if (!date) return ""; // avoid processing null/undefined
  const dateObj = new Date(date);
  if (isNaN(dateObj)) return ""; // invalid date check
  return format(dateObj, "dd MMM, yyyy");
};
  const weekDays = ["S", "M", "T", "W", "T", "F", "S"];
  const getDateYearsBefore = (years) => {
    const date = new Date();
    date.setFullYear(date.getFullYear() - years);
    return date;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevState) => ({
      ...prevState,
      [name]: value.trimStart(),
    }));
  };
  const handleVerify = (userId, status) => {
    if (userId) {
      dispatch(updateEditRequest({ userId }));
    }
  };

  useEffect(() => {
    setUser({
      _id: "66d1651e6759a6b81b81fdac",
      firstAndMiddleName: "Sushma",
      lastName: "K",
      email: "myclnq006@gmail.com",
      dateOfBirth: "2006-08-29T00:00:00.000Z",
      countryCode: "84",
      phoneNumber: "9844372845",
      gender: "Female",
      profilePic: null,
      hnNumber: "800009845",
    });
    setRawDate("2006-08-29T00:00:00.000Z");
  }, []);

  return (
    <div className="verification-request">
      {user && (
        <div className="pdl-info verify">
          <p className="pdl-title">{t("personalInformation")}</p>
          <div className="pdl-body">
            <div className="pdl-section-left">
              {editProfileData?.request?.relative.profilePhoto ? <img src={editProfileData.request.relative.profilePhoto} alt="profile" /> : <img src={Icons.noProfile} alt="profile" />}
              <p className="pdl-name prsnl-info">
                <input
                  type="text"
                  value={editProfileData?.request?.relative.firstName}
                  className="first-name-info"
                  name="firstName"
                  onChange={handleChange}
                  placeholder={t("placeholderFirstName")}
                  disabled={isDisabled}
                />
                <input type="text" onChange={handleChange} name="lastName" value={editProfileData?.request?.relative.lastName} placeholder={t("placeholderLastName")} disabled={isDisabled} />
              </p>
              <p className="pdl-gender">
                <Widgets.SelectDropdown
                  options={[`${t("male")}`, `${t("female")}`]}
                  selectedValue={editProfileData?.request?.relative.gender}
                  // onChange={(selectedValue) =>
                  //   setUserData((prevState) => ({
                  //     ...prevState,
                  //     gender: selectedValue,
                  //   }))
                  // }
                  placeholder="selectGender"
                  big
                  disabled={isDisabled}
                />
              </p>
            </div>
            <div className="pdl-section-right">
              <section className="pdl-phone-dob">
                <div className="pdl-detail">
                  <img src={Icons.Call} alt="call" />
                  <span>
                    +{editProfileData?.request?.relative.countryCode} {editProfileData?.request?.relative.phoneNumber}
                  </span>
                </div>
                <div className="pdl-detail date-pick">
                  <img src={Icons.CalenderIcon} alt="calender" />
                  <span> {editProfileData?.request?.relative?.dateOfBirth &&
                  getFormattedDate(editProfileData.request.relative.dateOfBirth)}</span>
                  <div className="custom-date-picker">
                    <DatePicker
                      value={editProfileData?.request?.relative?.dateOfBirth}
                      onChange={(date) => setRawDate(date)}
                      format="MM/DD/YYYY"
                      disabled={isDisabled}
                      editable={false}
                      weekDays={weekDays}
                      minDate={getDateYearsBefore(110)}
                      maxDate={getDateYearsBefore(16)}
                    />
                  </div>
                </div>
              </section>
              <section></section>
              <section className="pdl-detail">
                <img src={Icons.SmsIcon} alt="mail" />
                <span>{editProfileData?.request?.relative.email ? editProfileData?.request?.relative.email : t("notAvail") }</span>
              </section>
              <section className="pdl-hn">
                <p className="pdl-hn-title">
                  {t("hnNumber")}
                  <span className="asterik">*</span>
                </p>
                <p className="pdl-number">{editProfileData?.request?.relative.hnNumber ? editProfileData.request?.relative.hnNumber : t("--NA--")}</p>
              </section>
            </div>
          </div>
          <div className="save-speciality info">
            {status === "OPEN" ? (
              <>
                <div
                  className="speciality-save"
                  onClick={() => {
                    setPage(2);
                    handleVerify(editProfileData.request._id, editProfileData.request.status);
                  }}
                >
                  {t("assignYou")}
                </div>
              </>
            ) : (
              <div className="speciality-save" onClick={() => setPage(2)}>
                {t("next")}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default EditPersonalInfo;
